















import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { v4 as uuid } from 'uuid'
import { cloneDeep } from 'lodash'

@Component
export default class FacetInputCheckbox extends Vue {
    @Prop({ required: true }) options!: [{ label: string, value: string }]
    @Prop() value!: string[]
    internalValue: string[] = []
    internalName: string = null

    created(): void {
        this.internalName = uuid()
    }

    mounted(): void {
        this.onValueChanged()
    }

    @Watch('value')
    onValueChanged(): void {
        this.internalValue = cloneDeep(this.value)
    }

    @Watch('internalValue')
    onInternalValueChanged(): void {
        this.$emit('input', this.internalValue)
    }
}
